import { AppConfig, getBackendBaseUrl } from '../utils/config';

export type Kline = {
  time: number;
  open: number | string;
  high: number | string;
  low: number | string;
  close: number | string;
  volume?: number | string;
  [k: string]: any;
};

export async function fetchKlines(
  cfg: AppConfig | undefined,
  symbol: string,
  interval: string,
  limit: number = 2000
): Promise<Kline[]> {
  const base = getBackendBaseUrl(cfg);
  const url = `${base}/api/klines?symbol=${encodeURIComponent(symbol)}&interval=${encodeURIComponent(interval)}&limit=${encodeURIComponent(
    String(limit)
  )}`;
  const res = await fetch(url);
  if (!res.ok) throw new Error(`klines HTTP ${res.status}`);
  const json = await res.json();
  if (!json?.success) throw new Error(json?.message || 'klines failed');
  return (json.data || []) as Kline[];
}

export type AnalysisParams = {
  top_n?: number;
  min_correlation?: number;
  forward_periods?: number[];
};

export async function analyzeRectangle(params: {
  cfg: AppConfig | undefined;
  ohlc: Kline[];
  startIndex: number;
  endIndexExclusive: number;
  startTimeIso: string;
  endTimeIso: string;
  language?: 'en-US' | 'zh-CN';
  analysisParams?: AnalysisParams;
}): Promise<any> {
  const base = getBackendBaseUrl(params.cfg);
  const body = {
    ohlc_data: params.ohlc,
    rectangle: {
      start_index: params.startIndex,
      end_index: params.endIndexExclusive,
      start_time: params.startTimeIso,
      end_time: params.endTimeIso
    },
    analysis_params: {
      top_n: params.analysisParams?.top_n ?? 1000,
      min_correlation: params.analysisParams?.min_correlation ?? 0.8,
      forward_periods: params.analysisParams?.forward_periods ?? [10, 20, 30, 50, 100]
    },
    language: params.language ?? 'en-US'
  };
  const res = await fetch(`${base}/rectangle_similarity/analyze_rectangle`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body)
  });
  if (!res.ok) throw new Error(`analyze HTTP ${res.status}`);
  const json = await res.json();
  if (!json?.success) throw new Error(json?.error || 'analyze failed');
  return json;
}


